var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartsT"},[_vm._v(" "+_vm._s(_vm.lang.ParetoChart)+" "),_c('div',{ref:"chart",staticStyle:{"width":"100%","flex":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }